/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the UpgradeSubscriptionRequest interface.
 */
export function instanceOfUpgradeSubscriptionRequest(value) {
    if (!('tier' in value) || value['tier'] === undefined)
        return false;
    return true;
}
export function UpgradeSubscriptionRequestFromJSON(json) {
    return UpgradeSubscriptionRequestFromJSONTyped(json, false);
}
export function UpgradeSubscriptionRequestFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'tier': json['tier'],
    };
}
export function UpgradeSubscriptionRequestToJSON(json) {
    return UpgradeSubscriptionRequestToJSONTyped(json, false);
}
export function UpgradeSubscriptionRequestToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'tier': value['tier'],
    };
}
